import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-acheter',
  templateUrl: './menu-acheter.component.html',
  styleUrls: ['./menu-acheter.component.scss'],
})
export class MenuAcheterComponent {
  onNavigateCapacite() {
    window.open(
      'https://www.inandfi-credits.fr/calculette-capacite-emprunt',
      '_blank',
      'noopener,noreferrer'
    );
  }
}
